// extracted by mini-css-extract-plugin
export var askAiIcon = "_m3-9";
export var container = "_m3-0";
export var groupSeparator = "_m3-a";
export var highlight = "_m3-4";
export var resultIcon = "_m3-5";
export var resultItem = "_m3-7";
export var resultSubtitle = "_m3-3";
export var resultTitle = "_m3-2";
export var resultsList = "_m3-1";
export var searchGroup = "_m3-6";
export var selected = "_m3-8";